function initLoadMore() {
  const ajaxData = {
    action: 'load_posts',
  };

  const loadMore = new LoadMore(
    linku_ajax_url,
    null,
    '.js-load-more-posts',
    ajaxData,
    '.js-posts-grid',
  );

  loadMore.initClickHandling();
}

$(document).ready(() => {
  initLoadMore();
});
